import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import ApiService from '@/services/ApiService'
import router from '@/router'
import Vuelidate from 'vuelidate'
import store from '@/store'

Vue.use(Vuelidate)

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    ApiService
  }
})

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
